// extracted by mini-css-extract-plugin
export var csatScore = "_gr-5";
export var header = "_gr-1";
export var panelWrapper = "_gr-2";
export var postPreview = "_gr-3";
export var rightContent = "_gr-0";
export var wrappingText = "_gr-4";